import { arrayOf, exact, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const suggestionsType = arrayOf(
  exact({
    value: string.isRequired,
    label: string.isRequired,
  })
);
